import React, { lazy } from 'react';
const Home = lazy(() => import('../components/pages/Home'));

const homePage = () => {
    return (<Home />)
}

export default homePage;